import { Button } from '@/components/ui/button'

/**
 * Why Finish is disabled, under it, with a way to fix it: how many required
 * fields are left and a link to the first, or, once they're all filled, that
 * the signature still has to be adopted. Finish points to it with
 * `aria-describedby="finish-hint"`.
 */
export function FinishHint({
  remainingCount,
  onShowField,
  onAdopt,
}: {
  remainingCount: number
  onShowField: () => void
  onAdopt: () => void
}) {
  if (remainingCount > 0) {
    return (
      <p id="finish-hint" className="text-sm text-muted-foreground">
        {remainingCount === 1 ? '1 required field left.' : `${String(remainingCount)} required fields left.`}{' '}
        <Button type="button" variant="link" size="sm" onClick={onShowField}>
          Show me
        </Button>
      </p>
    )
  }
  return (
    <p id="finish-hint" className="text-sm text-muted-foreground">
      Adopt your signature to finish.{' '}
      <Button type="button" variant="link" size="sm" onClick={onAdopt}>
        Adopt signature
      </Button>
    </p>
  )
}
